const formatExpiry = (expMonth: number, expYear: number) =>
  `${expMonth.toString().padStart(2, "0")}/${expYear.toString().slice(-2)}`;

export default formatExpiry;
